import Upload from "./Upload";
import UploadCer from "./UploadCer";

export default Upload
export {UploadCer}